import { Component } from "react";
import { createRoot } from "react-dom/client";
import { ToastContainer, toast, TypeOptions } from "react-toastify";
import * as Helper from "./helper";
import { EventNames, listenEvent } from "../../portalEvents";
import { NotificationType } from "./helper";

interface IProps {}

class Notifications extends Component<IProps> {
    render() {
        return (
            <div>
                <ToastContainer />
            </div>
        );
    }

    componentDidMount() {
        listenEvent<Helper.IData>(EventNames.NotificationSent, (data) => {
            const decoratedMessages =
                data.messages.length === 1 ? (
                    <>{data.messages[0]}</>
                ) : (
                    <ul>
                        {data.messages.map((message) => (
                            <li>{message}</li>
                        ))}
                    </ul>
                );

            const notificationTypeName = NotificationType[data.type].toLowerCase();
            toast(decoratedMessages, { type: notificationTypeName as TypeOptions });
        });
    }
}

export const renderNotifications = (params: IProps, mountPoint: string) => {
    const container = document.getElementById(mountPoint);
    const root = createRoot(container);
    root.render(<Notifications {...params} />);
};
